import { useQuery } from '@tanstack/react-query';
import { loggedInUser } from 'hooks/use-logged-in-user';
import { useOrgService } from 'hooks/services/use-org-service';
import { IStaffMember } from 'types';

interface StaffMembersCache {
  staffMembers: IStaffMember[];
  isStaffMembersLoading: boolean;
  hasStaffMembers: boolean;
}

export const useStaffMembersCache = (): StaffMembersCache => {
  const orgService = useOrgService();
  const { isLoggedIn } = loggedInUser.useController();

  const staffMembersQuery = useQuery({
    queryKey: ['staffMembers'],
    queryFn: () => orgService.getUsers(),
    staleTime: Infinity,
    enabled: isLoggedIn
  });

  const staffMembers = staffMembersQuery.data ? staffMembersQuery.data : [];
  const isStaffMembersLoading = staffMembersQuery.isLoading;

  return {
    staffMembers,
    isStaffMembersLoading,
    hasStaffMembers: staffMembers.length > 0
  };
};
